module.exports = __webpack_public_path__ + "img/logo-graphic@3x.60baae9c.png";